









































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonPaymentTypeSelector from '@/components/Setting/CommonPaymentTypeSelector.vue';

import getCashflowCategory from '@/gql/cashflow/getCashflowCategory.gql';
import createCashflowCategory from '@/gql/cashflow/createCashflowCategory.gql';
import updateCashflowCategory from '@/gql/cashflow/updateCashflowCategory.gql';

const CommonFormWithCashFlowCategoryEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonPaymentTypeSelector,
  },
  props: {
    id: { type: [Number, String], default: -1 },
  },
  setup(props, { emit }) {
    const cashFlowCategory = reactive({
      name: '',
      type: 'VEHICLE',
    });

    const { result: cashFlowCategoryResult, loading } = useQuery(getCashflowCategory, computed(() => ({
      id: props.id,
    })), () => ({ fetchPolicy: 'network-only' }));
    const _cashFlowCategory = useResult(cashFlowCategoryResult, {}, (data) => data.cashFlowCategory);
    watch(() => cashFlowCategoryResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && props.id > -1) {
        cashFlowCategory.name = _cashFlowCategory.value.name;
        cashFlowCategory.type = _cashFlowCategory.value.type;
      }
    });

    const refetchQueryList = ['getCashflowCategories', 'getCashFlowStats'];
    const cashFlowCategoryInput = computed(() => ({
      name: cashFlowCategory.name,
      type: cashFlowCategory.type,
    }));

    const createCashFlowCategoryMutation = useMutation(createCashflowCategory, () => ({
      variables: {
        data: cashFlowCategoryInput.value,
      },
      refetchQueries: refetchQueryList,
    }));
    const updateCashFlowCategoryMutation = useMutation(updateCashflowCategory, () => ({
      variables: {
        id: props.id,
        data: cashFlowCategoryInput.value,
      },
      refetchQueries: refetchQueryList,
    }));

    const confirmModal = ref(null);
    createCashFlowCategoryMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateCashFlowCategoryMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createCashFlowCategoryMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateCashFlowCategoryMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.id !== -1) return updateCashFlowCategoryMutation;
      return createCashFlowCategoryMutation;
    });

    return {
      cashFlowCategory,

      computedMutation,

      confirmModal,
      errorModal,
    };
  },
});

export default CommonFormWithCashFlowCategoryEditor;
